import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const state = {
  products: [
    {
      id: 1,
      tribe: 'switcher',
      pureName: 'Switcher',
      name: 'Switcher 1버튼',
      price: '57,000',
      leasePrice: '8,550',
      discountedPrice: '45,600',
      iconUrl: require('@/assets/cart/cart-switcher1.png')
    },
    {
      id: 2,
      tribe: 'switcher',
      pureName: 'Switcher',
      name: 'Switcher 2버튼',
      price: '62,000',
      leasePrice: '9,300',
      discountedPrice: '49,600',
      iconUrl: require('@/assets/cart/cart-switcher2.png')
    },
    {
      id: 3,
      tribe: 'linker',
      pureName: 'Linker',
      name: 'Linker',
      price: '59,000',
      leasePrice: '8,850',
      discountedPrice: '47,200',
      iconUrl: require('@/assets/cart/cart-linker.png')
    },
    {
      id: 4,
      tribe: 'checker',
      pureName: 'Checker',
      name: 'Checker',
      price: '48,000',
      leasePrice: '7,200',
      discountedPrice: '38,400',
      iconUrl: require('@/assets/cart/cart-checker.png')
    }
  ],
  suggestionProducts: [
    {
      tribe: 'switcher',
      name: 'switcher',
      suggestionName: 'Switcher',
      suggestionDescription: '집 밖에서도 불을 끄고 싶다면',
      suggestionUrl: require('@/assets/suggestion-images/suggestion-switcher.png')
    },
    {
      tribe: 'linker',
      name: 'Linker',
      iconUrl: require('@/assets/cart/cart-linker.png'),
      suggestionName: 'Linker',
      suggestionDescription: '집 밖에서도 스위처를 사용하고 싶다면',
      suggestionUrl: require('@/assets/suggestion-images/suggestion-linker.png')
    },
    {
      tribe: 'checker',
      name: 'Checker',
      iconUrl: require('@/assets/cart/cart-checker.png'),
      suggestionName: 'Checker',
      suggestionDescription: '우리 집 도어 가드',
      suggestionUrl: require('@/assets/suggestion-images/suggestion-checker.png')
    }
  ],
  suggestions: [],
  numberOfCartItems: 0,
  cartItems: [],
  isSideMenuOpen: false,
  applicant: {},
  applicantProducts: [],
  firstPayAt: '',
  deliveryAt: '',
  amount: 0,
  leaseAmount: 0,
  discountedAmount: 0,
  promotionCustomerId: '',
  promotionCustomerName: '',
  promotionPaymentAmount: '',
  promotionBenefitAmount: ''
}

export const mutations = {
  toggleSideMenu (state, payload) {
    state.isSideMenuOpen = !state.isSideMenuOpen
  },
  insertItem (state, payload) {
    if (payload) {
      state.cartItems.push(payload)
      let index = state.suggestions.findIndex(x => x.tribe === payload.tribe)
      state.suggestions.splice(index, 1)
      state.numberOfCartItems = state.cartItems.length
    }
  },
  removeItem (state, payload) {
    if (payload) {
      let indexOfSuggestionProduct = state.suggestionProducts.findIndex(x => x.tribe === payload.tribe)
      state.suggestions.push(state.suggestionProducts[indexOfSuggestionProduct])
      let index = state.cartItems.findIndex(x => x.id === payload.id)
      state.cartItems.splice(index, 1)
      state.numberOfCartItems = state.cartItems.length
    }
  },
  initializeSuggestions (state, payload) {
    state.suggestionProducts.forEach(x => { state.suggestions.push(x) })
  },
  addApplicantInfo (state, payload) {
    state.applicant[payload.key] = payload.value
  },
  addApplicantProduct (state, payload) {
    state.applicantProducts.push(payload)
  },
  initApplicantData (state, payload) {
    state.applicant = {}
    state.applicantProducts = []
  },
  updateFirstPayAt (state, payload) {
    state.firstPayAt = payload
  },
  updateDeliveryAt (state, payload) {
    state.deliveryAt = payload
  },
  initCartItems (state, payload) {
    state.cartItems = []
    state.numberOfCartItems = state.cartItems.length
  },
  calculateAmounts (state, payload) {
    var sumOfAmount = 0
    var sumOfLeaseAmount = 0
    var sumOfDiscountedAmount = 0
    for (var i = 0; i < state.cartItems.length; i++) {
      sumOfAmount += Number(state.cartItems[i].price.replace(',', ''))
      sumOfLeaseAmount += Number(state.cartItems[i].leasePrice.replace(',', ''))
      sumOfDiscountedAmount += Number(state.cartItems[i].discountedPrice.replace(',', ''))
    }
    state.amount = sumOfAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    state.leaseAmount = sumOfLeaseAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    state.discountedAmount = sumOfDiscountedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  updatePromotionCustomerId (state, payload) {
    state.promotionCustomerId = payload
  },
  updatePromotionCustomerName (state, payload) {
    state.promotionCustomerName = payload
  },
  updatePromotionPaymentAmount (state, payload) {
    state.promotionPaymentAmount = payload
  },
  updatePromotionBenefitAmount (state, payload) {
    state.promotionBenefitAmount = payload
  }
}

const store = new Vuex.Store({
  state,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js